/* I88 has tag collision with ManageWatchList icon, but it's still in use so w/e */ import React from 'react';
import IconWrap from '../IconWrap';
const Filter = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9 17h6v1.5H9V17zm-2-6h10v1.5H7V11zM4 5h16v1.5H4V5z",
        fill: "currentColor"
    })));
Filter.displayName = 'Filter';
export default Filter;

//# sourceMappingURL=Filter.js.map